import { type FC } from "react"
import { Navigate, useParams } from "react-router"

import { parseIntNumber } from "@forento/shared/utilities/number"

import Layout from "~/themes/school/components/Layout"
import { PageBreadcrumb } from "~/themes/school/components/PageHeader"
import PartialLoadingPage from "~/themes/school/components/PartialLoadingPage"
import { useTranslation } from "~/translations"
import routes from "~/utilities/routes"
import { query } from "~/utilities/trpc"

import Content from "./Content"
import Result from "./Result"

const CourseExamPage: FC = () => {
	const courseId = parseIntNumber(useParams().courseId ?? "") ?? -1
	const t = useTranslation()

	const { data, error, refetch } = query.course.exam.getPersonalizedByCourse.useQuery(courseId, {
		staleTime: Infinity,
	})

	return (
		<Layout>
			<PageBreadcrumb
				title={t("course.exam.title")}
				path={[
					{ title: t("course.title"), link: routes.course.index() },
					{ title: data?.course.title ?? "...", link: routes.course.detail(courseId) },
				]}
			/>
			{error ? (
				<p>{t("failedToLoad")}</p>
			) : data === undefined ? (
				<PartialLoadingPage />
			) : data === null ? (
				<Navigate to={routes.course.detail(courseId)} />
			) : data.isCompleted ? (
				<Result exam={data} />
			) : (
				<Content examId={data.exam.id} questions={data.exam.questions} reload={refetch} />
			)}
		</Layout>
	)
}

export default CourseExamPage
